<template>
  <div class="radio-box-1 mb-3">
    <h5 class="radio-box-1-title">{{ inputConfig.title }}</h5>
    <div class="form-check form-check-inline" v-for="(option,index) in options" @click="refreshComponent">
      <input v-model="form[inputConfig.id]" :required="inputConfig.required" class="form-check-input " type="radio"

             :name="`radio_group_${inputConfig.hash}`" :id="`${inputConfig.hash}_${index}`" :value="option">
      <label class="form-check-label mr-1" :for="`${inputConfig.hash}_${index}`">{{ option.key }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioBox1",
  props: {
    inputConfig: {},
    form: {}
  },
  computed: {
    options() {
      return this.inputConfig.options
    },
  },
  methods:{
    refreshComponent() {
      this.$forceUpdate()
      this.$emit('refresh', true)
    }
  }
}
</script>

<style scoped>

</style>